import { createContext, useContext, useState } from "react";

const Context = createContext();

export function ThemeProvider({ children }) {
  const [email, setEmail] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);

  const reset = () => {
    setEmail("");
    setOtpSent(false);
    setOtpVerified(false);
  };

  return (
    <Context.Provider
      value={{
        email,
        setEmail,
        otpSent,
        setOtpSent,
        otpVerified,
        setOtpVerified,
        reset,
      }}
    >
      {children}
    </Context.Provider>
  );
}

export function useContextProvider() {
  return useContext(Context);
}